import React from 'react';

import BackgroundIcon from '@components/BackgroundIcon';
import RecordSync from '@components/RecordSync';
import SkeletonLoader from '@components/SkeletonLoader';
import AlertedPatientTable from '@components/Tables/AlertedPatientTable/AlertedPatientTable';
import WelcomeMessage from '@components/WelcomeMessage';

import { useGetAllPatientUsers } from '@hooks/api/user';
import { useIsMobile } from '@hooks/useIsMobile';
import { useSession } from '@hooks/useSession';

import AppLayout from '@layouts/AppLayout';
import { MainContainer } from '@layouts/Layouts/BigTitleLayout';

import Kpi from '@views/Dashboard/Kpi';

import { DashContents, DashboardStyle } from './ClientDashboard.style';
import Org from './Org';

/*
import { useTheme } from '@mui/material/styles';
import { useCuration } from '@hooks/useCuration';
import { defineMessages, useIntl } from 'react-intl';
import { Stack, Typography } from '@mui/material';
import { navigate } from 'gatsby';
import { AssignedUserDropdown } from '@components/AssignedUserDropdown';
import MuiDataTable from '@components/DataTable/MuiDataTable/MuiDataTable';
import { DialogListener } from '@components/Dialog';
import IconButton from '@components/IconButton';
import RecordSync from '@components/RecordSync';
import SkeletonLoader from '@components/SkeletonLoader';
import AlertTable from '@components/Tables/AlertTable';
import { Tag } from '@components/Tag';
import { RoleName } from '@constants/role_name';
import { PATIENTS } from '@constants/routes';
import TagContent from './Org/Modal/TagContent';
import { formatClientId, formatDate, formatName } from '@utils/format';
import type { AssignedPractitioner } from '@models/client';



import { useListAlerts } from 'generated/alert.generated';
import { AlertStatus } from 'generated/types';

*/

/*
const messages = defineMessages({
  noPatients: {
    id: 'curatorDashboard.noPatients',
    defaultMessage: 'No Patients',
  },
  noTasks: {
    id: 'curatorDashboard.noTasks',
    defaultMessage: 'No Tasks',
  },
  patients: {
    id: 'curatorDashboard.patients',
    defaultMessage: 'My Patients',
  },
  tasks: {
    id: 'curatorDashboard.tasks',
    defaultMessage: 'My Tasks',
  },
  onboardingPatients: {
    id: 'curatorDashboard.onboardingPatients',
    defaultMessage: 'My Onboarding Patients',
  },
  view: {
    id: 'curatorDashboard.view',
    defaultMessage: '{text} Record',
  },
  externalPatient: {
    id: 'organization.patient.status.external',
    defaultMessage: 'External Patient',
  },
  patientAlerts: {
    id: 'practitionerDashboard.patientAlerts',
    defaultMessage: 'My Patient Alerts',
  },
});


interface RowData {
  vitall_id: string;
  user_id: string;
  name: string;
  lastLogin?: string | null;
  lastRecordUpdate: string;
  newRecords?: number | null;
  needsReviewRecords?: number | null;
  draftRecords?: number | null;
  publishedRecords?: number | null;
  vitall_patient_id?: string | null;
  fhirID?: string | null;
  // true if patient is in org
  org_status: boolean;
  practitioner?: AssignedPractitioner;
}
*/

function PractitionerDashboard() {
  const mobile = useIsMobile();

  const {
    state: { loggedInProfile },
  } = useSession();

  const [first_name, user_id] = [
    loggedInProfile?.first_name,
    loggedInProfile?.user_id,
  ];

  const { data: patientsData, loading: patientsLoading } =
    useGetAllPatientUsers({ user_id });
  /*
  const { data: usersData, loading: usersLoading } = useGetAllUsers();
  const { data: alertsData, loading: alertsLoading } = useListAlerts({
    variables: {
      input: {
        account_id,
        status: [AlertStatus.open],
      },
    },
    skip: !account_id,
  });
  */
  const loading = patientsLoading;

  /*
  const userRenderFn = (value: string) => {
    const user = usersData?.find(({ user_id }) => user_id === value);
    if (!user) {
      return '(None)';
    }
    return formatName(user.first_name, user.last_name) ?? '';
  };


  const userSortFn = (
    user_id_a: string,
    user_id_b: string,
    order: 'asc' | 'desc'
  ) => {
    const getUser = (id?: string) => {
      if (!id) {
        return undefined;
      }
      const user = usersData?.find(({ user_id }) => user_id === id);
      return formatName(user?.first_name, user?.last_name);
    };
    const valA = getUser(user_id_a);
    const valB = getUser(user_id_b);
    if (!valA) {
      return 1;
    }
    if (!valB) {
      return -1;
    }
    return valA.localeCompare(valB) * (order === 'asc' ? 1 : -1);
  };
  */

  /*
  const patientData = (patientsData ?? []).map<RowData>(
    ({
      first_name,
      last_login,
      last_name,
      user_id,
      vitall_patient,
      vitall_user_id,
      account,
    }) => ({
      vitall_id: formatClientId(vitall_user_id ?? '', true),
      user_id: user_id,
      name: `${first_name} ${last_name}`,
      lastLogin: last_login,
      // TODO curator.curation_meta.last_record_update make last record update queryable in CurationMeta
      lastRecordUpdate: '-',
      newRecords: vitall_patient?.recordMeta?.New ?? 0,
      needsReviewRecords: vitall_patient?.recordMeta?.NeedsReview ?? 0,
      draftRecords: vitall_patient?.recordMeta?.Draft ?? 0,
      publishedRecords: vitall_patient?.recordMeta?.Published ?? 0,
      vitall_patient_id: vitall_patient?.vitall_patient_id,
      fhirID: vitall_patient?.patient_id,
      patient: vitall_patient,
      practitioner: {
        vitall_patient_id: vitall_patient?.vitall_patient_id,
        practitioner_user_id: vitall_patient?.practitioner?.user_id,
        first_name: vitall_patient?.practitioner?.first_name,
        last_name: vitall_patient?.practitioner?.last_name,
      },
      org_status: account.parent_id === loggedInProfile?.account_id,
    })
  );
  */

  return (
    <AppLayout>
      <BackgroundIcon />
      <DashboardStyle>
        {first_name ? <WelcomeMessage name={first_name} /> : null}
        <DashContents />
        {!mobile && <RecordSync />}
      </DashboardStyle>

      <Org.ActionButtons />

      <MainContainer height="auto">
        <Kpi />
        <SkeletonLoader loading={loading} height={250} width="100%">
          <AlertedPatientTable data={patientsData ?? []} />
        </SkeletonLoader>
      </MainContainer>
    </AppLayout>
  );
}

export default PractitionerDashboard;

{
  /*
     

        <SkeletonLoader loading={alertsLoading} height={400} width="100%">
          <AlertTable
            data={alertsData?.listAlerts ?? []}
            title={formatMessage(messages.patientAlerts)}
          />
        </SkeletonLoader>
        */
}

{
  /*
        <SkeletonLoader loading={loading} height={400} width="100%">
          <MuiDataTable
            columns={[
              {
                name: 'name',
                className: 'blue-hover',
                label: 'Patient Name',
                options: {
                  searchable: true,
                  sort: true,
                },
              },
              {
                name: 'practitioner',
                label: 'Practitioner',
                options: {
                  customBodyRender: (value: RowData['practitioner']) => (
                    <AssignedUserDropdown
                      name={formatName(value?.first_name, value?.last_name)}
                      vitall_patient_id={value?.vitall_patient_id}
                      value={value?.practitioner_user_id}
                      role={RoleName.Practitioner}
                    />
                  ),
                  filterType: 'multiselect',
                  filterOptions: {
                    renderValue: userRenderFn,
                  },
                  sort: true,
                  sortCompare: (order) => {
                    return (patientA, patientB) => {
                      return userSortFn(
                        patientA.data.practitioner_user_id,
                        patientB.data.practitioner_user_id,
                        order
                      );
                    };
                  },
                },
              },
              {
                name: 'lastLogin',
                className: 'date',
                label: 'Last Login Date',
                options: {
                  filter: true,
                  sort: true,
                  customBodyRender: (lastLogin?: string | null) =>
                    lastLogin
                      ? formatDate({ date: lastLogin, formatter: 'datetime' })
                      : '-',
                },
                desktopOnly: true,
              },
              {
                name: 'org_status',
                label: 'Status',
                options: {
                  customHeadLabelRender: (options) => {
                    return (
                      <DialogListener
                        content={<TagContent />}
                        dialogProps={{ maxWidth: 'xs' }}
                      >
                        {({ handleOpen }) => (
                          <Stack direction="row">
                            <Typography variant="h6">
                              {options.label}
                            </Typography>
                            <IconButton
                              onClick={handleOpen}
                              name="circle-question"
                              iconType="far"
                            />
                          </Stack>
                        )}
                      </DialogListener>
                    );
                  },
                  customBodyRender: (value: RowData['org_status']) =>
                    // If org_status === true, they are in the organization
                    value ? (
                      '-'
                    ) : (
                      <Tag
                        label={formatMessage(messages.externalPatient)}
                        color={primary.main}
                      />
                    ),
                },
              },
            ]}
            data={patientData}
            options={{
              onRowClick: (_rowData, { dataIndex }) => {
                if (dataIndex <= patientData.length - 1) {
                  const row = patientData[dataIndex];
                  const { user_id } = row;
                  viewAsPatient(user_id);
                  navigate(`${PATIENTS}${user_id}`);
                }
              },
              search: true,
              sort: true,
              filter: true,
              sortOrder: {
                name: 'name',
                direction: 'asc',
              },
              textLabels: {
                body: {
                  noMatch: formatMessage(messages.noPatients),
                },
              },
            }}
            title={formatMessage(messages.patients)}
          />
        </SkeletonLoader>
        */
}
